// extracted by mini-css-extract-plugin
module.exports = {"textContent":"_3kG8AHHIemIuDXIob_OmWq"};